import React from "react";
import ApplyForm from "@/components/ApplyForm";
import { useSiteContent } from "@/lib/siteContent";
import { becomeHostDefaults } from "@/pages/navPageDefaults";

export default function BecomeHost() {
  const content = useSiteContent();
  if (!content) return <div className="min-h-[60vh]" />;
  const c = { ...becomeHostDefaults, ...(content["become-host"] || {}) };
  return (
    <ApplyForm
      type="become_host"
      testId="become-host-page"
      title={c.title}
      subtitle={c.subtitle}
      image={c.image}
      blurb={c.blurb}
      extraFields={[
        { key: "venue_name", label: "Venue Name" },
        { key: "location", label: "Suburb / Town" },
        { key: "capacity", label: "Approx. seating capacity" },
      ]}
      messageLabel="Tell us about your venue and preferred nights"
    />
  );
}
